import { MODAL_ROOT_PATH } from '@wix/communities-blog-client-common/dist/src/constants/modal';
import { getIframes } from './get-iframes';

export function isWixModalIframePresent() {
  return getIframes().find(frame => frame.location.pathname === MODAL_ROOT_PATH);
}
